import { Injectable } from '@angular/core';
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytesResumable } from "firebase/storage";
import { StorageService } from './storage.service';
@Injectable({
    providedIn: "root"
})
export class FirebaseService {
    path = "admin/";

    constructor(
        public storage: StorageService,
    ) { }

    async upload(file: any, initialName: string = "") {
        return new Promise((resolve, reject) => {
            // const name = initialName ?? (Math.ceil(new Date().getTime() + Math.random() * new Date().getDate()).toString() + "-" + file.name);
            const name =  `public/locations/${Date.now()}-${file.name}`;
            const storage = getStorage();
            const storageRef = ref(storage, `${this.path}${name}`);
            const metadata = {
                contentType: file.type
            };
            const uploadTask = uploadBytesResumable(storageRef, file, metadata);
            uploadTask.on('state_changed',
                (snapshot) => {
                    file.progress = (snapshot.bytesTransferred / (snapshot.totalBytes * 1.2)) * 100;
                },
                (error) => {
                    reject(error);
                },
                async () => {
                    var obj: any = {
                        file: {
                            mimetype: file.type,
                            originalname: file.name,
                            fileName: "file",
                            encoding: "7bit",
                            size: file.size
                        }
                    }
                    obj.url = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(obj);
                }
            );
        });
    }

    async deleteFromStorage(url: string) {
        const storage = getStorage();
        const storageRef = ref(storage, url);
        await deleteObject(storageRef);
    }

    async downloadFile(url: string) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
            const blob = xhr.response;
        };
        xhr.open('GET', url);
        xhr.send();
    }

}
